/**
 * @generated SignedSource<<85212f7c80061bfdd73d1bc37ee0bcbc>>
 * @relayHash 5213d657213d4f20b4cbab0ef09e4592
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/546.0.0-2026-02-10T15:55:41.181Z/NftPdpBidModalContextQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModalContextQuery$variables = {
  fetchUser: boolean;
  userId: string;
};
export type NftPdpBidModalContextQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_viewer">;
  };
};
export type NftPdpBidModalContextQuery = {
  response: NftPdpBidModalContextQuery$data;
  variables: NftPdpBidModalContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftPdpBidModalContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftPdpBidModalContext_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftPdpBidModalContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                  }
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "socialNetworkName",
                        "value": "ETHEREUM"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "socialNetworkByName",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumSocialConnectionUserPreferencesType",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zipCode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EthereumSocialConnection",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/546.0.0-2026-02-10T15:55:41.181Z/NftPdpBidModalContextQuery",
    "metadata": {},
    "name": "NftPdpBidModalContextQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "63a2df73a7aa4df537483e007f18372a";

export default node;
